module.exports = __webpack_public_path__ + "static/media/logo_ue.434d168e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_ue.svg
// module id = 324
// module chunks = 0